/**
 * Contrato de renderizacao do corpo (Secao 15.5, camada 3).
 *
 * Vem duplicado de `@waymail/mime` de proposito: aquele pacote e de servidor
 * (usa `node:crypto`), e trazer ele para o bundle do navegador so por uma
 * constante custaria mais que as tres linhas aqui.
 */
export const contratoDeRenderizacao = {
  sandbox: 'allow-popups allow-popups-to-escape-sandbox',
  origemDeConteudo: 'https://content.waymail.app',
} as const;

/** As duas URLs relativas que o sanitizador gera: proxy de imagem e imagem inline (ADR 0048). */
const IMAGEM_RELATIVA = /src="\/api\/v1\/(proxy\/image\?|inline\/)/g;

/**
 * O sanitizador assina a imagem com caminho relativo, porque a API nao sabe o
 * proprio endereco publico atras do proxy. Dentro do `srcdoc` relativo resolve
 * contra a origem da web, que nao serve `/api` - em dev e em producao, onde web
 * e API tem dominios separados. Toda imagem liberada chegava quebrada.
 *
 * Completa so os prefixos que o proprio sanitizador gera, entre aspas duplas
 * como ele serializa: o do proxy e o da imagem inline (`cid:`), que tambem
 * mora na API. Um `<base>` resolveria de uma vez, mas a CSP da pagina tem
 * `base-uri 'none'`, e o `srcdoc` herda a CSP de quem o contem.
 */
export function apontarImagensParaApi(html: string, origemDaApi: string): string {
  return html.replace(IMAGEM_RELATIVA, (_, resto: string) => `src="${origemDaApi}/api/v1/${resto}`);
}
